import React from "react";
import { Link } from "react-router-dom";
import fImg1 from "../../images/election-donation/1.svg";
import fImg2 from "../../images/election-donation/2.svg";
import fImg3 from "../../images/election-donation/3.svg";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Features2 = (props) => {
  return (
    <section className="wpo-election-donation-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-12">
            <div className="election-donation-item">
              <div className="logo">
                <img src={fImg1} alt="Our Campaign" />
              </div>
              <div className="text">
                <h2>OUR CAMPAIGN</h2>
                <p>
                  Join Taisha St. Jean Tard's movement to bring transparency,
                  fairness, and growth to our community. Together, we can shape
                  a better future for everyone.
                </p>
                <div className="icon">
                  <Link onClick={ClickHandler} to="/campaign">
                    <i className="ti-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="election-donation-item color-2">
              <div className="logo">
                <img src={fImg2} alt="Become a Volunteer" />
              </div>
              <div className="text">
                <h2>BECOME A VOLUNTEER</h2>
                <p>
                  Make a meaningful impact in our community! Volunteer with
                  Taisha’s campaign and help drive positive change for our
                  future.
                </p>
                <div className="icon">
                  <Link onClick={ClickHandler} to="/volunteer">
                    <i className="ti-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <div className="election-donation-item color-3">
              <div className="logo">
                <img src={fImg3} alt="Make a Donation" />
              </div>
              <div className="text">
                <h2>MAKE A DONATION</h2>
                <p>
                  Your support fuels our mission for a fairer, more inclusive
                  future. Every contribution brings us closer to our goal.
                </p>
                <div className="icon">
                  <Link onClick={ClickHandler} to="/donate">
                    <i className="ti-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features2;
